import $ from "jquery";

export const validationRequired = (thisEl, wrapper = null) => {
    wrapper =
        wrapper != null
            ? wrapper
            : thisEl.parentsUntil("details[open]").parent();

    if ($(".AccountPage__LoginRegister__Left__Form__ButtonNext").length > 0) {
        wrapper = thisEl.parent().siblings("details[open]");
    }
    // if ($(".SingleInfoCarForm").length > 0) {
    //     wrapper = thisEl.parentsUntil("#js_form_update_product").parent();
    // }
    const requiredInput = wrapper.find(
        "input[required]:visible, select[required]:visible, textarea[required]:visible, input#inspection-date-plan[required], #input-additional-maintenance select[required], #input-additional-maintenance input[required], div#url_image",
    );
    // const requiredInput = wrapper.find(
    //     "input[required]:visible, select[required]:visible, textarea[required]:visible, input#inspection-date-plan[required]:visible, #input-additional-maintenance select[required], #input-additional-maintenance input[required], #input-additional-accessories input[required], #input-additional-accessories select[required], div#url_image",
    // );

    const errors = [];
    $(requiredInput).each(function () {
        let wrapperInput = $(this).closest("details[open] .Form__Field");
        if (
            $(".SingleInfoCarForm").length > 0 ||
            $(".Contact__FormWrapper").length > 0
        ) {
            wrapperInput = $(this).parentsUntil(".Form__Field").parent();
        }

        const wrapperInputEl =
            wrapperInput.length > 0 ? wrapperInput : $(this).parent();

        wrapperInputEl.find("span.js-error-message").hide();
        const isUploadImage = $(this).attr("id") === "url_image";
        const isImageExist = isUploadImage
            ? $(this).parent().find(".dz-preview").length === 0
            : false;
        const isEmptyNull =
            !isUploadImage && ($(this).val() === "" || $(this).val() === null); // for another input except upload image

        //to check if current input is email
        if ($(this).attr("type") === "email") {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const isValidEmail = emailPattern.test($(this).val());

            if (!isValidEmail) {
                wrapperInputEl.find("span.js-error-message").show();
                errors.push(true);
            }
        }
        //to check if current input is upload image
        if (
            (isUploadImage && isImageExist) ||
            (!isUploadImage && isEmptyNull)
        ) {
            // console.log(wrapperInputEl);
            wrapperInputEl.find("span.js-error-message").show();
            errors.push(true);
        }
    });

    if (errors.length > 0) return false;

    return true;
};

export const validationRepeat = (selector, repeatSelector) => {
    if ($(selector).length === 0 || $(repeatSelector).length === 0) {
        return true;
    }

    $(repeatSelector).parent().siblings(".password-message").hide();
    if (
        $(selector).val() === "" ||
        $(repeatSelector).val() === "" ||
        $(selector).val() !== $(repeatSelector).val()
    ) {
        $(repeatSelector).parent().siblings(".password-message").show();
        return false;
    }

    return true;
};
